import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  color?: string
}

export default function PriceTagIcon({ color = '#101010' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05376 0.418835L11.0861 0.913819L11.5811 5.94616L6.3303 11.1969C5.77074 11.7565 4.89586 11.7565 4.3363 11.1969L0.802971 7.66361C0.243411 7.10405 0.243411 6.22918 0.802971 5.66962L6.05376 0.418835ZM6.61285 1.98107L1.92729 6.66662L5.3333 10.0726L10.0189 5.38707L9.71384 2.28608L6.61285 1.98107Z"
        fill={color}
      />
      <path
        d="M8.00016 4.66671C8.36835 4.66671 8.66683 4.36823 8.66683 4.00004C8.66683 3.63185 8.36835 3.33337 8.00016 3.33337C7.63197 3.33337 7.3335 3.63185 7.3335 4.00004C7.3335 4.36823 7.63197 4.66671 8.00016 4.66671Z"
        fill={color}
      />
    </svg>
  )
}
